const API_BASE = import.meta.env.VITE_API_BASE ?? "";
const legacyTokenKey = "callforward.token";
const tokenKeys = {
    ADMIN: "callforward.admin.token",
    USER: "callforward.user.token"
};
export function getToken(role = inferRoleFromPath()) {
    return localStorage.getItem(tokenKeys[role]);
}
export function setToken(token, role) {
    localStorage.setItem(tokenKeys[role], token);
    localStorage.removeItem(legacyTokenKey);
}
export function clearToken(role) {
    if (role) {
        localStorage.removeItem(tokenKeys[role]);
        return;
    }
    localStorage.removeItem(tokenKeys.ADMIN);
    localStorage.removeItem(tokenKeys.USER);
    localStorage.removeItem(legacyTokenKey);
}
async function request(path, options = {}) {
    const { authRole, ...fetchOptions } = options;
    const token = getToken(authRole ?? inferRoleForRequest(path));
    const response = await fetch(`${API_BASE}${path}`, {
        ...fetchOptions,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...fetchOptions.headers
        }
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error ?? response.statusText);
    }
    return response.json();
}
function inferRoleForRequest(path) {
    if (path.startsWith("/api/admin"))
        return "ADMIN";
    if (path.startsWith("/api/user"))
        return "USER";
    return inferRoleFromPath();
}
function inferRoleFromPath() {
    return window.location.pathname.startsWith("/admin") ? "ADMIN" : "USER";
}
export const api = {
    captcha: () => request("/api/auth/captcha", { method: "POST" }),
    async login(body) {
        return request("/api/auth/login", {
            method: "POST",
            body: JSON.stringify(body)
        });
    },
    totpSetup: (preAuthToken) => request(`/api/auth/totp/setup?preAuthToken=${encodeURIComponent(preAuthToken)}`),
    totpEnable: (body) => request("/api/auth/totp/enable", { method: "POST", body: JSON.stringify(body) }),
    totpVerify: (body) => request("/api/auth/totp/verify", { method: "POST", body: JSON.stringify(body) }),
    me: (role) => request("/api/me", { authRole: role }),
    adminStats: () => request("/api/admin/stats"),
    adminUsers: () => request("/api/admin/users"),
    createUser: (body) => request("/api/admin/users", { method: "POST", body: JSON.stringify(body) }),
    updateUser: (id, body) => request(`/api/admin/users/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
    deleteUser: (id) => request(`/api/admin/users/${id}`, { method: "DELETE" }),
    createNumber: (body) => request("/api/admin/numbers", { method: "POST", body: JSON.stringify(body) }),
    updateNumber: (id, body) => request(`/api/admin/numbers/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
    deleteNumber: (id) => request(`/api/admin/numbers/${id}`, { method: "DELETE" }),
    rotateNumberApiKey: (id) => request(`/api/admin/numbers/${id}/api-key`, { method: "POST" }),
    adminCalls: () => request("/api/admin/calls"),
    adminSettings: () => request("/api/admin/settings"),
    updateSettings: (body) => request("/api/admin/settings", { method: "PATCH", body: JSON.stringify(body) }),
    userNumbers: () => request("/api/user/numbers"),
    dial: (id) => request(`/api/user/numbers/${id}/calls`, { method: "POST" }),
    cancelCall: (id) => request(`/api/user/calls/${id}/cancel`, { method: "POST" }),
    userCalls: () => request("/api/user/calls")
};
